import Vue from "vue"

export default {
  data: function () {
    return {
      states: {
        standart: { "transition-timing-function": "var(--trans-standart)" },
        decelerate: { "transition-timing-function": "var(--trans-decelerate)" },
      },
      aniSpeed: 0.15,
      selectedAniState: "standart",
    }
  },
  computed: {
    anistate: function () {
      const ret = this.states[this.selectedAniState]

      if (!ret) return {}
      else {
        ret["transition-duration"] = this.aniSpeed + "s"
        return ret
      }
    },
  },
  methods: {
    changeAniSate: function (state, cb) {
      if (this.states[state] === undefined)
        console.warn(state + " is not a valid anistate")
      this.selectedAniState = state
      Vue.nextTick(() => {
        if (typeof cb === "function") cb()
      })
    },
  },
}
